<template>
  <right-banner-template :title="title">
    <div v-if="isLoading">
      <base-spinner></base-spinner>
    </div>
    <div class="qa-content" v-else style="--swiper-theme-color: black;">
      <div class="box-container">
        <button v-for="(qa, index) in getQuestionData" :key="index" @click.prevent="showAnswer(index)">
          <span v-if="$store.state.lang === 'vn'">{{ qa.question_vn }}</span>
          <span v-else>{{ qa.question_en }}</span>

          <div v-if="activeIndex === index" class="answer-box">
            <div class="line"></div>
            <div v-if="$store.state.lang === 'vn'" v-html="qa.answer_vn" class="ql-editor"></div>
            <div v-else v-html="qa.answer_en" class="ql-editor"></div>
            <!-- <p >{{  }}</p>
            <p >{{ qa.answer_en }}</p> -->
          </div>
        </button>

      </div>
    </div>
  </right-banner-template>
</template>

<script>
export default {
  props: ['title'],
  data () {
    return {
      activeIndex: null,
      isLoading: false
    }
  },
  computed: {
    getQuestionData () {
      return this.$store.getters['question/getQuestion']
    }
  },
  methods: {
    showAnswer (index) {
      this.activeIndex = this.activeIndex === index ? null : index
    }
  },
  async mounted () {
    this.isLoading = true
    this.activeIndex = null
    await this.$store.dispatch('question/getQuestionData')
    this.isLoading = false
  }
}
</script>

<style scoped>

  .box-container {
    width: 100%;
  }
  .box-container button {
    text-align: left;
    /* font-weight: bold; */
    border: 1px solid #dddddd;
    background-color: #fff;
    padding: 10px;
    line-height: 1.5;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 10px;
    border-radius: 3px;
    position: relative;
    width: 100%;
  }

  /* .box-container span{
    font-weight: bold;
    line-height: 1.5;
    font-size: 14px;
  } */

  .answer-box {
    margin-top: 10px;
  }

  .line {
    height: 1px;
    width: 80%;
    background: #dddddd;
    margin: 0 auto;
  }

  .answer-box p {
    margin-top: 10px;
    /* color: rgb(78, 132, 189); */
  }
</style>
